module.exports = __webpack_public_path__ + "static/img/3_1_7.b3cd4cfc.jpg";